export default __webpack_public_path__ + "static/media/wrathoftheserpentring.7d2415a0.png";